import authService from './authService';
import { readData } from './apiResponse';
import type { AppSettings, AppSettingsPatch } from '../types/planning';

/**
 * Administração → Configurações (só admin): liberação geral do Acervo CAC, cadastro aberto (login
 * com Google cria a conta) e dias de teste.
 */
class SettingsService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /admin/settings */
  async get(): Promise<AppSettings> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/admin/settings');
    return readData<AppSettings>(response, 'Falha ao carregar as configurações');
  }

  /** PUT /admin/settings { cac_enabled_for_all?, signup_enabled?, trial_days? } — ao menos um campo. */
  async updateSettings(patch: AppSettingsPatch): Promise<AppSettings> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.put('/admin/settings', patch);
    return readData<AppSettings>(response, 'Falha ao salvar as configurações');
  }

  /** Atalho: PUT /admin/settings { cac_enabled_for_all }. */
  async update(cacEnabledForAll: boolean): Promise<AppSettings> {
    return this.updateSettings({ cac_enabled_for_all: cacEnabledForAll });
  }
}

export const settingsService = new SettingsService();
export default settingsService;
